/**
 * @module use-cases/app/helpers
 *
 */

import type { App } from 'core/domains';

/**
 * Get screen size breakpoint
 */
export function getScreenSize(): App['screenSize'] {
  const windowWidth = window.innerWidth;
  let screenSize = 'xs';

  if (windowWidth >= 1920) {
    screenSize = 'xxl';
  } else if (windowWidth >= 1280) {
    screenSize = 'xl';
  } else if (windowWidth >= 1024) {
    screenSize = 'lg';
  } else if (windowWidth >= 880) {
    screenSize = 'im';
  } else if (windowWidth >= 768) {
    screenSize = 'md';
  } else if (windowWidth >= 480) {
    screenSize = 'sm';
  } else if (windowWidth >= 400) {
    screenSize = 'ix';
  } else {
    screenSize = 'mxs';
  }

  return screenSize as App['screenSize'];
}
